const rodzajSerwisu = { type: 'radio', name: 'serwis', options: ['Autoryzowany', 'Niezalezny'], tOptions: ['Serwis autoryzowany', 'Serwis niezależny']}
export default rodzajSerwisu